module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp2_9005.be62f314.png";